export default {
  login: 'Sign in',
  register: 'Sign up',
  forgotPassword: 'Forgot password',
  resetPassword: 'Reset password',
  home: 'Home',
  accountManage: 'Accounts',
  roleManage: 'Roles',
  permissionManage: 'Permissions',
  companyManage: 'Companies',
  eventManage: 'Events',
  eventCreate: 'New event',
  eventEdit: 'Edit event',
  eventLocation: 'Location',
  eventRegistration: 'Registration',
  eventSchedule: 'Schedule',
  registrationManage: 'Registrations',
  eventMicrosite: 'Microsite',
  eventMicrositeEditor: 'Page editor',
  micrositeH5: 'Event microsite',
  albumCreate: 'New album',
  albumEdit: 'Edit album',
  photoManage: 'Photos',
  aiRetouch: 'AI retouch',
  baseInfo: 'Basic info',
  privacySettings: 'Privacy',
  topPromotion: 'Top banner',
  launchPoster: 'Launch poster',
  loadingImage: 'Loading image',
  basicAd: 'Basic ad',
  bottomPromotionBar: 'Bottom bar',
  batchWatermark: 'Batch watermark',
  sideAd: 'Side ad',
  infoCard: 'Info card',
  largeImageDetail: 'Large image detail',
  photographerWorkbench: 'Photographer',
  retouchWorkbench: 'Retoucher',
  qcWorkbench: 'QC',
  auditorWorkbench: 'Auditor',
  defaultWorkflow: 'Default workflow'
}
